import { render, staticRenderFns } from "./rankingGeral.vue?vue&type=template&id=5c30dd14"
import script from "./rankingGeral.vue?vue&type=script&lang=js"
export * from "./rankingGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports